"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceIdToCxTupleArgs = void 0;
const i18n_args_1 = require("./i18n-args");
const config_type_1 = require("../config-type");
/**
 * Input args to be used for a MarketplaceId to CXID data query.
 */
class MarketplaceIdToCxTupleArgs extends i18n_args_1.I18nArgs {
    constructor(_obfuscatedMarketplaceId) {
        super();
        this._obfuscatedMarketplaceId = _obfuscatedMarketplaceId;
    }
    get obfuscatedMarketplaceId() {
        return this._obfuscatedMarketplaceId;
    }
    getConfigType() {
        return config_type_1.ConfigType.MARKETPLACEID_TO_CX_TUPLE;
    }
    getArgsMap() {
        return new Map([
            ['obfuscated_marketplace_id', this._obfuscatedMarketplaceId]
        ]);
    }
}
exports.MarketplaceIdToCxTupleArgs = MarketplaceIdToCxTupleArgs;
/**
 * Builder class that build the {@link MarketplaceIdToCxIdArgs} instance.
 */
MarketplaceIdToCxTupleArgs.Builder = class {
    /**
     * Sets the ObfuscatedMarketplaceId within the {@link MarketplaceIdToCxIdArgs}
     * container.
     *
     * @param id    Obfuscated Marketplace ID to be used for the config query.
     *
     * @return builder instance
     */
    withObfuscatedMarketplaceId(id) {
        this.obfuscatedMarketplaceId = id;
        return this;
    }
    /**
     * Builds the {@link MarketplaceIdToCxIdArgs} class using the previously set
     * properties.
     *
     * @return {@link MarketplaceIdToCxIdArgs} class instance
     */
    build() {
        return new MarketplaceIdToCxTupleArgs(this.obfuscatedMarketplaceId);
    }
};
//# sourceMappingURL=marketplaceId-to-cx-tuple-args.js.map